import { useTranslation } from 'react-i18next'
import { SessionState } from '../state/types'

export function QuestionPrompt({ session }: Readonly<{ session: SessionState }>) {
  const { t } = useTranslation()
  const q = session.pendingQuestion
  if (!q) return null
  return (
    <div className={`copilot-railcard ${q.terminal ? 'copilot-railcard--muted' : 'copilot-railcard--info'}`}>
      <p>{q.text}</p>
      {q.terminal && (
        <small className="text-muted" data-testid="copilot-question-terminal">
          {t('copilot.question.portalNotice')}
        </small>
      )}
    </div>
  )
}
